import { IApprovalsServiceMock } from "./approvals.types";

export const mockApprovalsService = (): IApprovalsServiceMock => ({
  getOrders: jest.fn(),
});
